import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './NotebookDeletePopup.css';
import NotebookLang from './NotebookLang.json';

class NotebookDeletePopup extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookID: 0,
			notebookJsonObj: null,
			notebookDeleteYN: false,
		}
	}
		
	async componentDidMount() {
	}

	async componentDidUpdate() {

		var notebookID1 = this.state.notebookID;
		var notebookID2 = this.props.notebookID;
		
		if (notebookID2 === 0) {
			return;
		}

		if (notebookID1 === notebookID2) {
			return;
		}

		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID2);
		this.setState({
			notebookJsonObj: notebookJsonObj,
			notebookID: notebookID2,
		});
	}

	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickDeleteButton();
		}
	}

	onPopUpClosed() {
		this.props.setNotebookDeletePopupYN(false);
	}

	onTitleChanged(value) {
		this.setState({title: value});
	}
	
	async serverDeleteNotebook(notebookID) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/deletenotebook?notebookid=" + notebookID;
		
		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
		}

		return responseText;
	}

	async onClickDeleteButton() {
		
		this.setState({notebookDeleteYN: true});

		var notebookID = this.state.notebookID;
		await this.serverDeleteNotebook(notebookID);

		this.setState({notebookDeleteYN: false});

		var toastString = this.props.getLang(NotebookLang, "notebookDeleted");
		this.props.showToast(toastString);
		this.onPopUpClosed();
		this.props.refreshData();
	}
	
	onClickCancelButton() {
		this.onPopUpClosed();
	}
	
	renderButtons() {
		
		var notebookDeleteYN = this.state.notebookDeleteYN;
		if (notebookDeleteYN) {
			return;
		}

		return (
				<div className="ViewContainerButtons2">
					<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(NotebookLang, "cancel")}</button>
					<div style={{width: "20px"}}></div>
					<button className="ViewSaveButton" onClick={() => this.onClickDeleteButton()}>{this.props.getLang(NotebookLang, "delete")}</button>
				</div>
		);
	}
	renderContent() {

		var notebookJsonObj = this.state.notebookJsonObj;
		var title = notebookJsonObj.title;
		
		return (
			<div className="NotebookDeletePopupTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="NotebookDeletePopupTitle">{this.props.getLang(NotebookLang, "deleteNotebook")}</div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "20px"}}></div>
				<div className="ViewContainer2">
					<fieldset className="NotebookDeletePopupFieldset">
						<legend className="NotebookDeletePopupLegend">{this.props.getLang(NotebookLang, "notebookTitle")}</legend> 
						<input
							className="NotebookDeletePopupInput" 
							disabled={true}
							id="title" 
							type="text" 
							value={title}
							onChange={(event) => this.onTitleChanged(event.target.value)}
							onKeyDown={(event) => this.onKeyDown(event.keyCode)}
						/>
					</fieldset>
				</div>
				<div style={{height: "20px"}}></div>
				<div className="NotebookDeletePopupWarining">{this.props.getLang(NotebookLang, "deleteWarning")}</div>
				<div style={{height: "30px"}}></div>
				{this.renderButtons()}
				<div style={{height: "20px"}}></div>				
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		return (
			<Popup
				className="notebook-delete-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default NotebookDeletePopup;

